var _rect, _path, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1649_4593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1649_4593)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22.8978C21.6151 22.8978 20.0016 22.2267 18.6595 20.8846C17.3171 19.5422 16.6458 17.9285 16.6458 16.0436C16.6458 14.1587 17.3171 12.5452 18.6595 11.2031C20.0016 9.86067 21.6151 9.18945 23.5 9.18945C25.3849 9.18945 26.9984 9.86067 28.3405 11.2031C29.6829 12.5452 30.3542 14.1587 30.3542 16.0436C30.3542 17.9285 29.6829 19.5422 28.3405 20.8846C26.9984 22.2267 25.3849 22.8978 23.5 22.8978ZM8.8125 37.8115V33.4576C8.8125 32.4987 9.07296 31.6106 9.59388 30.7933C10.1148 29.976 10.811 29.3477 11.6824 28.9084C13.6179 27.9596 15.5705 27.2479 17.5403 26.7733C19.5101 26.2988 21.4966 26.0615 23.5 26.0615C25.5034 26.0615 27.4899 26.2988 29.4597 26.7733C31.4295 27.2479 33.3821 27.9596 35.3176 28.9084C36.189 29.3477 36.8852 29.976 37.4061 30.7933C37.927 31.6106 38.1875 32.4987 38.1875 33.4576V37.8115H8.8125ZM11.75 34.874H35.25V33.4576C35.25 33.061 35.1351 32.6939 34.9053 32.356C34.6756 32.0186 34.3637 31.7431 33.9697 31.5296C32.2823 30.6986 30.5619 30.069 28.8086 29.6408C27.0549 29.2129 25.2853 28.999 23.5 28.999C21.7147 28.999 19.9451 29.2129 18.1914 29.6408C16.4381 30.069 14.7177 30.6986 13.0303 31.5296C12.6363 31.7431 12.3244 32.0186 12.0947 32.356C11.8649 32.6939 11.75 33.061 11.75 33.4576V34.874ZM23.5 19.9603C24.5771 19.9603 25.4991 19.5768 26.2661 18.8098C27.0332 18.0428 27.4167 17.1207 27.4167 16.0436C27.4167 14.9665 27.0332 14.0445 26.2661 13.2775C25.4991 12.5105 24.5771 12.127 23.5 12.127C22.4229 12.127 21.5009 12.5105 20.7339 13.2775C19.9668 14.0445 19.5833 14.9665 19.5833 16.0436C19.5833 17.1207 19.9668 18.0428 20.7339 18.8098C21.5009 19.5768 22.4229 19.9603 23.5 19.9603Z",
    fill: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1649_4593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 3,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 3,
    width: 16,
    height: 16,
    fill: "#FF4C4C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1649_4593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6013 14.1028L38.0013 11.7028L40.4013 14.1028L41.1038 13.4003L38.7038 11.0003L41.1038 8.60033L40.4013 7.89783L38.0013 10.2978L35.6013 7.89783L34.8988 8.60033L37.2988 11.0003L34.8988 13.4003L35.6013 14.1028ZM38.0025 17.3337C37.1265 17.3337 36.3031 17.1674 35.5323 16.835C34.7615 16.5025 34.0911 16.0514 33.521 15.4815C32.9509 14.9116 32.4995 14.2414 32.1668 13.471C31.8342 12.7005 31.668 11.8774 31.668 11.0015C31.668 10.1255 31.8342 9.3021 32.1666 8.53133C32.4991 7.76055 32.9502 7.0901 33.5201 6.51999C34.09 5.94988 34.7602 5.49849 35.5306 5.16583C36.3011 4.83327 37.1242 4.66699 38.0001 4.66699C38.8761 4.66699 39.6995 4.83321 40.4703 5.16566C41.2411 5.4981 41.9115 5.94927 42.4816 6.51916C43.0517 7.08905 43.5031 7.75921 43.8358 8.52966C44.1684 9.3001 44.3346 10.1233 44.3346 10.9992C44.3346 11.8752 44.1684 12.6985 43.836 13.4693C43.5035 14.2401 43.0524 14.9105 42.4825 15.4807C41.9126 16.0508 41.2424 16.5022 40.472 16.8348C39.7015 17.1674 38.8784 17.3337 38.0025 17.3337Z",
    fill: "#FF4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6013 14.1028L38.0013 11.7028L40.4013 14.1028L41.1038 13.4003L38.7038 11.0003L41.1038 8.60033L40.4013 7.89783L38.0013 10.2978L35.6013 7.89783L34.8988 8.60033L37.2988 11.0003L34.8988 13.4003L35.6013 14.1028Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person (2).27edccbec09d4a0ca6a1b586205b112b.svg";
export { ForwardRef as ReactComponent };